<template>
    <div class="box-filtros">
        <div class="content-container row">
            <div class="form-padrao">

                <div class="box-flex">
                    <template v-for="filter in filters">

                       <div v-if="filter.type === 'autocomplete'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <autocomplete class="custom-auto-complete"
                                          :source="filter.url"
                                          :results-property="getProperty(filter)"
                                          :results-display="getDisplay(filter)"
                                          :resultsFormatter="formatter"
                                          :name="filter.name"
                                          v-model="filter.value"
                                          placeholder="">
                            </autocomplete>
                       </div>

                        <div v-if="filter.type === 'static-text'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <div class="autocomplete custom-auto-complete" value="0001">
                                <div class="autocomplete__box">
                                    <div class="autocomplete__inputs">
                                        <input type="text" disabled :value="filter.value">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="filter.type === 'select'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <b-form-select class="mb-3" v-model="filter.value">
                                <option v-for="option in filter.options" :value="option.value">{{option.description}}</option>
                            </b-form-select>
                        </div>

                        <div v-if="filter.type === 'checkbox'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <b-form-group >
                                <b-form-radio-group
                                        :options="filter.options"
                                        :name="filter.name"
                                        class="custom-checkbox"
                                        v-model="filter.value">
                                </b-form-radio-group>
                            </b-form-group>
                        </div>

                        <div v-if="filter.type === 'multibox'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <b-form-group>
                                <b-form-checkbox-group
                                        id="checkbox-group-1"
                                        :options="filter.options"
                                        :name="filter.name"
                                        class="custom-checkbox"
                                        v-model="filter.value">
                                </b-form-checkbox-group>
                            </b-form-group>
                        </div>

                        <div v-if="filter.type === 'period'" :class="getClass(filter)">
                             <label>{{ getLabelName(filter) }}:</label>
                            <div class="flex-form calendar">
                                <datepicker :language="dateOptions.pt" :format="dateOptions.format" :selected="highlightFrom"></datepicker>
                                <span class="periodo-a">a</span>
                                <datepicker :language="dateOptions.pt" :format="dateOptions.format" :selected="highlightTo"></datepicker>
                            </div>
                        </div>

                        <div v-if="filter.type === 'date'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <div class="flex-form calendar">
                                 <datepicker :language="dateOptions.pt"
                                             :format="dateOptions.format"
                                             v-model="filter.value">
                                 </datepicker>
                            </div>
                        </div>

                        <div v-if="filter.type === 'date-month'" :class="getClass(filter)">
                            <label>{{ getLabelName(filter) }}:</label>
                            <div class="flex-form calendar">
                                 <vue-monthly-picker
                                         dateFormat="MM/YYYY"
                                         v-model="filter.value">
                                </vue-monthly-picker>
                            </div>
                        </div>

                        <div v-if="filter.type === 'multiselect'" :class="getClass(filter)">
                             <label>{{ getLabelName(filter) }}:</label>
                            <multiselect
                                    :multiple="true"
                                    :name="filter.name"
                                    :options="filter.options"
                                    v-model="filter.value">
                            </multiselect>
                        </div>

                        <div v-if="filter.type === 'multiselect-axios'" :class="getClass(filter)" style="margin-bottom: 0.5em">
                            <label>{{ getLabelName(filter) }}:</label>
                            <multiselect v-model="filter.value"
                                         id="ajax"
                                         track-by="id"
                                         label="descricao"
                                         open-direction="bottom"
                                         :show-labels="false"
                                         :placeholder="filter.placeholder"
                                         :multiple="true"
                                         :searchable="true"
                                         :options="multiselectOptions"
                                         :loading="isLoading"
                                         :internal-search="false"
                                         :clear-on-select="false"
                                         :close-on-select="false"
                                         :options-limit="300"
                                         :limit="40"
                                         :max-height="600"
                                         :show-no-results="false"
                                         :hide-selected="true"
                                         @search-change="e => getOptions(e, filter.url)">
                                <template slot="tag" slot-scope="{ option, remove }">
                                    <span class="custom__tag" style="display: inline-block; margin: 0.6em">
                                        <span @click="remove(option)" style="border: 1px solid #00AFEF; border-radius: 1em; cursor: pointer; padding: 0 0.2em">
                                            {{ option.cnpj }}
                                        </span>
                                    </span>
                                </template>
                                <template slot="clear">
                                    <div class="multiselect__clear" v-if="filter.value.length" @mousedown.prevent.stop="clearAll()"></div>
                                </template>
                                <template slot="limit">
                                    <div class="multiselect__limit">e mais {{filter.value.length - 40}}</div>
                                </template>
                                <template slot="noOptions">
                                    <div>Lista vazia</div>
                                </template>
                                <span slot="noResult">Oops! Nenhum registro encontrado! Tente mudar os temos de busca.</span>
                            </multiselect>
                        </div>
                    </template>
                </div>

                <div class="box-button" v-if="filters && filters.length > 0">
                    <button class="btn-padrao" @click="emit">EXECUTAR</button>
                </div>

                <div class="close-filters">
                    <a href="#" class="filters-button" @click="e => abrriFiltro(e)"><i class="icon-down-open"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import VueMonthlyPicker from 'vue-monthly-picker';
    import {ptBR} from 'vuejs-datepicker/dist/locale';
    import Multiselect from 'vue-multiselect';
    import axios from 'axios';

    export default {
        name: "Filtros",
        components: {
            Datepicker, Multiselect, VueMonthlyPicker
        },
        props:{
            filters: Array
        },
        data() {
            return {
                dateOptions: {
                    format: "dd/MM/yyyy",
                    pt: ptBR
                },
                isLoading: false,
                multiselectOptions: []
            }
        },
        methods: {
            highlightTo(val)
            {
                if (typeof this.highlighted.to === "undefined") {
                    this.highlighted = {
                        to: null,
                        daysOfMonth: this.highlighted.daysOfMonth,
                        from: this.highlighted.from
                    };
                }
                this.highlighted.to = val;
            },
            abrriFiltro(e)
            {
                e.preventDefault();
                $('.close-filters').parent('.form-padrao').toggleClass('closedfilters');
            },
            highlightFrom()
            {
                if (typeof this.highlighted.from === "undefined") {
                    this.highlighted = {
                        to: this.highlighted.to,
                        daysOfMonth: this.highlighted.daysOfMonth,
                        from: null
                    };
                }
            },
            getLabelName(filter)
            {
                return filter.hasOwnProperty('label') ? filter.label : filter.name.charAt(0).toUpperCase() + filter.name.slice(1);
            },
            getClass(filter)
            {
                return filter.hasOwnProperty('class') ? 'relative-form ' + filter.class : 'relative-form column-3';
            },
            getProperty(filter)
            {
                return filter.hasOwnProperty('property') ? filter.property : 'id';
            },
            getDisplay(filter)
            {
                return filter.hasOwnProperty('display')  ? filter.display  : 'description';
            },
            getOptions(query, url)
            {
                if (query.length >= 3 && !this.isLoading)
                {
                    this.isLoading = true;

                    axios.get(url + query).then((response) => {
                        this.multiselectOptions =[];

                        if (response.data.success)
                        {
                            let data  = Object.values(response.data.records);
                            let scope = this;

                            data.forEach(function (value) {
                                scope.multiselectOptions.push({
                                    id: value.id,
                                    cnpj: value.cnpj,
                                    descricao: value.cnpj + ' - ' + value.nome + ' - ' + value.cidade + ' / ' + value.estado
                                });
                            });
                        }

                        this.isLoading = false;
                    });
                }
            },
            clearAll ()
            {
                this.multiselectOptions = []
            },
            emit()
            {
                this.$emit('changeFilters', this.filters);
            }
        },
    }
    
</script>